import { property } from 'lodash'
import { createSelector } from '@reduxjs/toolkit'

import { hasBetaAccess } from 'utils/beta'

export const
  aioKeySelector = state => state.keys.keys[0].key,

  userSelector = state => state.session.user,

  usernameSelector = createSelector(userSelector, property("username")),

  userTimezoneSelector = createSelector(userSelector, property("time_zone")),

  isAdmin = createSelector(userSelector, user => user?.role === "admin"),

  subscriptionSelector = createSelector(userSelector, property("subscription")),

  hasIoPlusSelector = createSelector(subscriptionSelector,
    (subscription={}) => (subscription.status === 'active') && subscription.plan.paid
  ),

  hasDeviceFlagSelector = createSelector(userSelector, user => {
    return hasBetaAccess(user, 'devices')
  }),

  canUseDevicesSelector = createSelector(hasIoPlusSelector, hasDeviceFlagSelector,
    (hasIoPlus, hasDeviceFlag) => hasIoPlus && hasDeviceFlag
  ),

  canSeeDesignGuide = isAdmin
